var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-checkbox"},[_c('CheckboxComponent',{attrs:{"value":_vm.value,"label":_vm.$attrs.options.label},on:{"input":$ev => _vm.$emit('input', $ev)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }